// 默认配置
export default {
    capKey: '9bce764f222f26fd94eede1322c5cb6b',
    product: 'ursmaillogin',
    promark: 'dDiOfyc',
    pkht: 'id.163.com',
    needpp: 1,
    needEye: 1,
    suffixDomains: '@163.com,@126.com,@yeah.net,@188.com,@vip.163.com,@vip.126.com',
    logoSize: 'width:auto;height:40px',
    cookieDomains: '',
    // 默认免登标记，不支持
    needUnLogin: 0,
    // 默认免登状态，非勾选
    defaultUnLogin: 0,
    // 默认是否显示邮箱广告， 不显示
    showMailAd: 0
}


// WEBPACK FOOTER //
// ./src/util/constant.js